module.exports = __webpack_public_path__ + "img/KH.b3dadd9f.svg";